import {
    cn_object_parameters_input,
    PARAM_STATUS_CUSTOM_VALUE,
    PARAM_STATUS_USE_DEFAULT_VALUE,
    PARAM_STATUS_VARIABLE,
} from '../svg/cn_inputs';
import { cn_pastille } from '../svg/cn_pastille';

export function add_params_pastille(instances, transaction_manager, context, readonly) {
    const source = instances[0].object.source;
    const parameters_pastille = new cn_pastille([0, 0], 'text.svg');
    parameters_pastille.svg_class = 'pastille_background white';
    parameters_pastille.title = "Paramètres de l'équipement";

    //*** Pastille click method :  */
    parameters_pastille.clicked = () => {
        //*** Build input */
        const input = new cn_object_parameters_input();
        const distinctLabels = new Set(
            instances.map((it) => it.object.get_label())
        );
        input.label =
            distinctLabels.size === 1
                ? distinctLabels.values().next().value
                : '';
        input.product_type = source.product_type;
        input.parameters = [];
        input.readonly = readonly;

        //*** Fill codes & values */
        const codes = [];
        const typesValueByCode = new Map();
        const instanceDistinctValuesByCode = new Map();
        for (let code in source.parameters) {
            codes.push(code);
            typesValueByCode.set(code, source.parameters[code]);
        }
        instances.forEach((instance) => {
            for (let code in instance.parameters) {
                if (!codes.includes(code)) {
                    codes.push(code);
                }
                if (!instanceDistinctValuesByCode.has(code)) {
                    instanceDistinctValuesByCode.set(code, new Set());
                }
                instanceDistinctValuesByCode
                    .get(code)
                    .add(instance.parameters[code]);
            }
        });

        //*** Fill input parameters */
        const inputParams = [];
        codes.forEach((code) => {
            //*** Get type & instance values */
            const typeValue = typesValueByCode.get(code);
            const instanceDistinctValues =
                instanceDistinctValuesByCode.get(code) || new Set();
            //*** Get status */
            let status;
            const allDistinctValues = new Set();
            if (typeValue != null) {
                allDistinctValues.add(typeValue);
            }
            instanceDistinctValues.forEach((val) => allDistinctValues.add(val));

            if (instances.length === 1) {
                switch (allDistinctValues.size) {
                    case 0:
                        status = PARAM_STATUS_USE_DEFAULT_VALUE;
                        break;
                    case 1:
                        if (typeValue != null) {
                            status = PARAM_STATUS_USE_DEFAULT_VALUE;
                        } else {
                            status = PARAM_STATUS_CUSTOM_VALUE;
                        }
                        break;
                    default:
                        status = PARAM_STATUS_CUSTOM_VALUE;
                        break;
                }
            } else {
                switch (allDistinctValues.size) {
                    case 0:
                        status = PARAM_STATUS_USE_DEFAULT_VALUE;
                        break;
                    case 1:
                        if (typeValue != null) {
                            status = PARAM_STATUS_USE_DEFAULT_VALUE;
                        } else if (
                            instances.every(
                                (instance) =>
                                    instance.parameters[code] ===
                                    instanceDistinctValues.values().next().value
                            )
                        ) {
                            status = PARAM_STATUS_CUSTOM_VALUE;
                        } else {
                            status = PARAM_STATUS_VARIABLE;
                        }
                        break;
                    default:
                        if (
                            instanceDistinctValues.size === 1 &&
                            instances.every(
                                (instance) =>
                                    instance.parameters[code] ===
                                    instanceDistinctValues.values().next().value
                            )
                        ) {
                            status = PARAM_STATUS_CUSTOM_VALUE;
                        } else {
                            status = PARAM_STATUS_VARIABLE;
                        }
                        break;
                }
            }

            //*** Get effective value */
            let effectiveValue;
            switch (status) {
                case PARAM_STATUS_USE_DEFAULT_VALUE:
                    effectiveValue = typeValue;
                    break;
                case PARAM_STATUS_CUSTOM_VALUE:
                    effectiveValue = instanceDistinctValues
                        .values()
                        .next().value;
                    break;
                case PARAM_STATUS_VARIABLE:
                    effectiveValue = undefined;
                    break;
            }

            const inputParam = {
                code_bim: code,
                default_value: typeValue,
                value: effectiveValue,
                status: status,
            };
            inputParams.push(inputParam);
        });
        input.parameters = inputParams;

        //*** Input callback */
        input.callback = () => {
            transaction_manager.push_transaction("Modification d'équipements");
            instances.forEach((it) => {
                transaction_manager.push_item_set(it, ['parameters']);
            });
            input.parameters.forEach((p) => {
                if (p.status === PARAM_STATUS_USE_DEFAULT_VALUE) {
                    instances.forEach((i) => delete i.parameters[p.code_bim]);
                } else if (p.status === PARAM_STATUS_CUSTOM_VALUE) {
                    instances.forEach(
                        (i) => (i.parameters[p.code_bim] = p.value)
                    );
                }
            });
        };

        context.call('object_parameters_input', input);
    };

    return parameters_pastille;
}
